import { isArray, isPlainObject, isString } from 'lodash/fp';
import { Markdown, PortableText } from '@ahmdigital/ui';
import React from 'react';

// @ts-expect-error - Automatic, Please fix when editing this file
const wrapItemBody = (body) => {
  if (React.isValidElement(body)) {
    return body;
  }
  if (isString(body)) {
    return <Markdown>{body}</Markdown>;
  }
  if (isPlainObject(body) || isArray(body)) {
    return <PortableText source={body} />;
  }

  return null;
};

export default wrapItemBody;
